import React from "react";
import moment from "moment";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { Typography, Row, Col, Button } from "antd";

import DataTable from "../../../../Components/DataTable";
import * as surveyActions from "../../../../actionCreators/Survey";
import ViewSurvey from "./ViewSurvey";

import "./style/surveyListing.css";

const SurveyListing = ({
  surveys,
  getSurveys,
  userData,
  openSurveyUsersListing,
}) => {
  const [data, setData] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [pagination, setPagination] = React.useState({});
  const [openViewSurvey, setOpenViewSurvey] = React.useState(true);
  const [rowData, setRowData] = React.useState(null);

  React.useEffect(() => {
    getSurveys({ page: 0, pageSize: 10, user_id: userData.id });
  }, []);

  React.useEffect(() => {
    if (surveys.data) {
      setData(surveys.data);
      setPagination(surveys.pagination);
      setLoading(surveys.loading);
    }
  }, [surveys]);

  const handleTablePageChange = (tableChangeData) => {
    const { current, pageSize } = tableChangeData;
    getSurveys({ page: current - 1, pageSize, user_id: userData.id });
  };

  const tableColumns = [
    {
      title: "Owner Name",
      dataIndex: "survey_owners",
      width: "20%",
      render: (survey_owners) =>
        survey_owners.length > 0 ? survey_owners[0].name : "---",
    },
    {
      title: "Circle",
      dataIndex: "circle",
      width: "20%",
      render: (circle) => (circle ? circle.name : "---"),
    },
    {
      title: "Locality",
      dataIndex: "locality",
      render: (locality) => (locality ? locality : "---"),
    },
    {
      title: "Survey Date",
      dataIndex: "survey_date",
      render: (survey_date) =>
        survey_date ? moment(survey_date).format("DD MMMM YYYY") : "---",
    },
    {
      title: "Serial Number",
      dataIndex: "serial_number",
      render: (serial_number) => (serial_number ? serial_number : "---"),
    },
    {
      title: "Status",
      dataIndex: "approval_status",
      render: (approval_status, row) => {
        if (approval_status === null && row.submission_type === "submitted") {
          return "Awaiting Approval";
        } else if (approval_status === "approved") {
          return "Approved";
        } else if (approval_status === "rejected") {
          return "Rejected";
        }
      },
    },
  ];

  const onTableRowClick = (data) => {
    setRowData(data);
    setOpenViewSurvey(false);
  };

  return (
    <React.Fragment>
      {openViewSurvey ? (
        <div>
          <Row>
            <Col span={12}>
              <Typography className="heading">
                General Survey /{" "}
                <b>{userData.full_name ? userData.full_name : null}</b>
              </Typography>
            </Col>
            <Col span={12}>
              <div className="top-button-wrap">
                <Button
                  className="close-property-button"
                  onClick={openSurveyUsersListing}
                >
                  Back
                </Button>
              </div>
            </Col>
          </Row>
          <DataTable
            columns={tableColumns}
            pagination={pagination}
            loading={loading}
            data={data}
            handleTableValuesChange={handleTablePageChange}
            onRowClick={onTableRowClick}
          />
        </div>
      ) : (
        <ViewSurvey
          rowData={rowData}
          closeViewSurvey={() => setOpenViewSurvey(true)}
          inspectorName={userData.full_name}
        />
      )}
    </React.Fragment>
  );
};

const mapStateToProps = ({ survey: { surveys } }) => ({ surveys });

const mapDispatchToProps = (dispatch) => ({
  getSurveys: bindActionCreators(surveyActions.getSurveys, dispatch),
});

SurveyListing.propTypes = {
  userData: PropTypes.object.isRequired,
  surveys: PropTypes.object.isRequired,
  getSurveys: PropTypes.func.isRequired,
  openSurveyUsersListing: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(SurveyListing);
